<template>
  <div class="success-message">
    <p v-html="message"></p>
  </div>
</template>

<style lang="scss" scoped>
  .success-message {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 100000;
    background-color: #1dc105;
    padding: 10px 15px;
    min-width: 100px;
    color: #fff;

    p {
      font-size: 1.4rem;
    }
  }
</style>
<script>
export default {
  name: "KaaliSuccess",
  components: {
  },
  props: {
    message: String
  },
  data() {
    return {

    }
  },
  computed: {
  }
};
</script>
